import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { getPcMainScrollElement } from './main-simplebar.js';

const button = document.querySelectorAll('[data-dropdown]');
const content = document.querySelectorAll('.header__nav-sub');

if (window.innerWidth < 1024) {
  button.forEach((btn, index) => {
    const target = content[index];
    if (!btn || !target) return;
    btn.addEventListener('click', event => {
      event.preventDefault();
      target.classList.toggle('opened');
    });
  });
}

const button2 = document.querySelectorAll('.js-dropdown');
const content2 = document.querySelectorAll('.js-dropdownBody');

button2.forEach((btn2, index) => {
  const target2 = content2[index];
  if (!btn2 || !target2) return;
  btn2.addEventListener('click', event => {
    event.preventDefault();

    if (btn2.classList.contains('is_open')) {
      btn2.classList.remove('is_open');
      slideUp(target2, 500);
    } else {
      btn2.classList.add('is_open');
      slideDown(target2, 500);
    }
  });
});

// slideUp
const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + "px";
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

// slideDown
const slideDown = (el, duration = 300) => {
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");
  setTimeout(() => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(max-width: 768px)');
  const navList = document.querySelector('.header-navList');
  if (!navList) return;

  const getItemByLabel = label =>
    navList.querySelector(`[data-label="${label}"]`);

  const originalOrder = [...navList.children];

  const reorderNavForSP = () => {
    if (mq.matches) {
      const order = [
        '医院紹介',
        'ドクター紹介',
        '症例',
        '料金案内',
        'アクセス',
        '院内ツアー',
        'キャンセルポリシー',
        '診療案内',
        'NEWS',
        'COLUMN',
        'CONTACT'
      ];

      order.forEach(label => {
        const item = getItemByLabel(label);
        if (item) navList.appendChild(item);
      });
    } else {
      // PCに戻ったら元の順に戻す
      originalOrder.forEach(item => navList.appendChild(item));
    }
  };

  reorderNavForSP();
  mq.addEventListener('change', reorderNavForSP);
});

/** 対応業務アコーディオンで下のセクション位置が変わるため、ScrollTrigger（例: .svcSystem__card）を再計算 */
function refreshScrollTriggerAfterSvcBusinessLayout() {
  requestAnimationFrame(function () {
    ScrollTrigger.refresh();
  });
}

var SVC_BUSINESS_SECTION_ID = 'sec-service-business';
var SVC_BUSINESS_HASH = '#' + SVC_BUSINESS_SECTION_ID;
var SVC_BUSINESS_CARD_HASH_RE = /^#svc-business-card-([1-6])$/;

function scrollSvcDeepLinkTargetIntoView(targetEl) {
  if (!targetEl) return;
  var scrollMargin =
    parseInt(window.getComputedStyle(targetEl).scrollMarginTop, 10) || 0;
  var scrollEl = getPcMainScrollElement();
  if (scrollEl && scrollEl !== document.documentElement && scrollEl !== document.body) {
    var nextTop =
      scrollEl.scrollTop +
      targetEl.getBoundingClientRect().top -
      scrollEl.getBoundingClientRect().top -
      scrollMargin;
    scrollEl.scrollTop = Math.max(0, nextTop);
  } else {
    var top =
      targetEl.getBoundingClientRect().top +
      (window.scrollY || document.documentElement.scrollTop) -
      scrollMargin;
    window.scrollTo(0, Math.max(0, top));
  }
}

/**
 * ディープリンク: #svc-business-card-N または（旧）?business=N#sec-service-business
 * @returns {{ index: number, scrollEl: HTMLElement | null } | null}
 */
function parseSvcBusinessDeepLinkState(openPanelByIndex) {
  var max = openPanelByIndex.length;
  if (max < 1) return null;

  var cardMatch = location.hash.match(SVC_BUSINESS_CARD_HASH_RE);
  if (cardMatch) {
    var n = parseInt(cardMatch[1], 10);
    if (n < 1 || n > max) return null;
    var scrollEl = document.getElementById('svc-business-card-' + n);
    return { index: n, scrollEl: scrollEl || null };
  }

  if (location.hash !== SVC_BUSINESS_HASH) return null;
  var params = new URLSearchParams(window.location.search);
  var raw = params.get('business');
  if (raw === null || raw === '') return null;
  var idx = parseInt(raw, 10);
  if (!Number.isFinite(idx) || idx < 1 || idx > max) return null;
  return {
    index: idx,
    scrollEl: document.getElementById(SVC_BUSINESS_SECTION_ID),
  };
}

/** ハッシュ・クエリに応じて対応業務カードを開き、スクロール位置を合わせる */
function applySvcBusinessDeepLink(openPanelByIndex) {
  var parsed = parseSvcBusinessDeepLinkState(openPanelByIndex);
  if (!parsed) return;

  var idx = parsed.index;
  var scrollTarget =
    parsed.scrollEl ||
    document.getElementById('svc-business-card-' + idx) ||
    document.getElementById(SVC_BUSINESS_SECTION_ID);

  function run() {
    var open = openPanelByIndex[idx - 1];
    if (typeof open === 'function') open();
    scrollSvcDeepLinkTargetIntoView(scrollTarget);
  }

  requestAnimationFrame(function () {
    requestAnimationFrame(run);
  });
}

/** サービスページ: 対応業務カードのヘッダークリックで詳細リストを開閉 */
function initSvcBusinessAccordion() {
  var grid = document.querySelector('.svcBusiness__grid');
  if (!grid) return;

  var animMs = 320;
  var settleMs = animMs + 16;

  var cards = grid.querySelectorAll('.svcBusiness__card');
  /** @type {(() => void)[]} */
  var openPanelByIndex = [];

  cards.forEach(function (card) {
    var outer = card.querySelector('.svcBusiness__cardOuter');
    var dropdown = card.querySelector('.svcBusiness__dropdown');
    if (!outer || !dropdown) return;

    function openPanel() {
      if (card.classList.contains('is-open')) return;
      dropdown.removeAttribute('hidden');
      outer.setAttribute('aria-expanded', 'true');
      card.classList.add('is-open');
      slideDown(dropdown, animMs);
      refreshScrollTriggerAfterSvcBusinessLayout();
      setTimeout(refreshScrollTriggerAfterSvcBusinessLayout, settleMs);
    }

    function closePanel() {
      outer.setAttribute('aria-expanded', 'false');
      card.classList.remove('is-open');
      slideUp(dropdown, animMs);
      refreshScrollTriggerAfterSvcBusinessLayout();
      setTimeout(refreshScrollTriggerAfterSvcBusinessLayout, settleMs);
      setTimeout(function () {
        dropdown.setAttribute('hidden', '');
      }, settleMs);
    }

    function togglePanel() {
      if (card.classList.contains('is-open')) {
        closePanel();
      } else {
        openPanel();
      }
    }

    openPanelByIndex.push(openPanel);

    outer.addEventListener('click', function (e) {
      e.preventDefault();
      togglePanel();
    });

    outer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        togglePanel();
      }
    });
  });

  applySvcBusinessDeepLink(openPanelByIndex);
  window.addEventListener('hashchange', function () {
    applySvcBusinessDeepLink(openPanelByIndex);
  });

  setTimeout(function () {
    var parsed = parseSvcBusinessDeepLinkState(openPanelByIndex);
    if (!parsed) return;
    var el =
      parsed.scrollEl ||
      document.getElementById('svc-business-card-' + parsed.index) ||
      document.getElementById(SVC_BUSINESS_SECTION_ID);
    scrollSvcDeepLinkTargetIntoView(el);
  }, 400);
}

document.addEventListener('DOMContentLoaded', function () {
  initSvcBusinessAccordion();
});
